export const statusText: { [key: number]: string } = {
    0: 'не оплачен',
    1: 'принят',
    2: 'собираем',
    3: 'в пути',
    4: 'уже у вас',
    5: 'отменен'
}

export const statusIcons: { [key: number]: JSX.Element } = {
  1: <i className="fi fi-sr-check-circle" />,
  2: <i className="fi fi-sr-box-open" />,
  3: <i className="fi fi-sr-shipping-fast" />,
  4: <i className="fi fi-sr-house-chimney" />,
  5: <i className="fi fi-sr-circle-xmark" />,
};